import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';

export const authMiddleware: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (action.payload?.data?.message === 'Invalid JWT Token.') {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }

    return next(action);
  };
